import { Images } from "config/images";

export const MENU_FOOTER = [
	{
		title: "Trang chủ",
		link: "/home",
		icon: Images.icHome,
		iconActive: Images.icHomeActive,
		isShow: true
	},
	{
		title: "Giỏ hàng",
		link: "/carts",
		icon: Images.icCart,
		iconActive: Images.icCartActive,
		isShow: true
	},
	{
		title: "Tài khoản",
		link: "/user",
		icon: Images.icUser,
		iconActive: Images.icUserActive,
		isShow: true
	}
];

export const MENU_FOOTER_SHOW = ["/home", "/order", "/user"];

export const MENU_HEADER_SHOW = [
	"/order_confirmation",
	"/carts",
	"/order_history",
	"/order_history_detail",
	"/change_password",
	"/delete_account",
	"/special_offer",
	"/promotion_detail",
	"/special_offer_detail",
	"/info_loyalty",
	"/merchandising_detail",
	"/news",
	"/signature"
];

export const BACKGROUND_YELLOW = ["/special_offer_detail"];

export const TITLE_MENU_HEADER_SHOW = {
	order_confirmation: "Giỏ hàng",
	carts: "Giỏ hàng",
	order_history: "Lịch sử đơn hàng",
	order_history_detail: "Chi tiết đơn hàng",
	change_password: "Thay đổi mật khẩu",
	delete_account: "Xóa tài khoản",
	special_offer: "Chương trình khuyến mãi",
	promotion_detail: "Chi tiết chương trình khuyến mãi",
	special_offer_detail: "Chương trình tích luỹ",
	info_loyalty: "Tích luỹ",
	merchandising_detail: "Chương trình trưng bày",
	news: "Thông báo",
	signature: "Biên bản thoả thuận"
};
